import { Routes } from '@angular/router'; 
import { CardsComponent } from './pages/client/cards/cards.component'; 
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { ForbiddenComponent } from './pages/forbidden/forbidden.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { AppLoginLayout } from './pages/layout/component/login/app.login.layout';
import { AppClientLayout } from './pages/layout/component/client/app.client.layout';
import { RedirectComponent } from './pages/redirect/RedirectComponent';
import { authRedirectGuard } from './guards/auth-redirect.guard';


export const routes: Routes = [
  {
    path: '',
    component: RedirectComponent,
    canActivate: [authRedirectGuard],
    pathMatch: 'full'
  },
  {
    path: 'client',
    component: AppClientLayout,
    //canActivate: [autoLoginPartialRoutesGuard],
    children: [
      { path: '', redirectTo: 'cards', pathMatch: 'full' },
      { path: 'cards/:id', component: CardsComponent }
    ]
  },
  {
    path: 'auth',
    component: AppLoginLayout,
    children: [
      { path: 'client', component: CardsComponent }
    ]
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent,
    canActivate: [autoLoginPartialRoutesGuard],
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: '**', redirectTo: '/auth/client' },
];
